import { BaseGraphResult, BaseGraphResultDateItem } from '@prerender/prerender-shared';

export function transformToCategories<T extends BaseGraphResultDateItem>(
  graphResult: BaseGraphResult<T>,
  categoryFn: (item: T) => string,
  valueFn: (item: T) => any
) {
  const getKey = (time: string, category: string) => category + '_' + time;

  const hashMap = new Map();
  const categories = new Set<string>();

  graphResult.data.forEach((item) => {
    const category = categoryFn(item);

    categories.add(category);
    const key = getKey(item.time, category);

    if (hashMap.has(key)) {
      throw new Error(`duplicate value for key=${key}`);
    }

    hashMap.set(key, valueFn(item));
  });

  const result: Record<string, any[]> = {};

  categories.forEach((category: string) => {
    result[category] = [];

    graphResult.intervals.forEach((time) => {
      const key = getKey(time, category);

      if (hashMap.has(key)) {
        result[category].push(hashMap.get(key));
      } else {
        result[category].push(null);
      }
    });
  });

  return result;
}
